(function () {
    "use strict";

    angular.module('iMatApp')
        .factory('urlService', urlService);

    urlService.$inject = ['$window', '$http', 'guard'];

    function urlService($window, $http, guard) {
        var service = {
            setHash: setHash,
            setHashParameters: setHashParameters,
            getHashParameters: getHashParameters,
            removeHashParameters: removeHashParameters,

            getCurrentAbsoluteUrl: getCurrentAbsoluteUrl,
            shorten: shorten
        };

        return service;

        // *******************************************************************************
        
        function setHash(str) {
            $window.location.hash = str;
        }

        function setHashParameters(obj) {
            var newHash = $.param(obj, true);
            setHash(newHash);
        }

        function getHashParameters() {
            var hash = $window.location.hash.substr(1);
            if (hash.length === 0) {
                return {};
            }

            var params = getParameters(hash);
            return params;
        }

        function removeHashParameters() {
            // remove fragment as much as it can go without adding an entry in browser history:
            $window.location.replace("#");

            // slice off the remaining '#' in HTML5:    
            if (angular.isFunction($window.history.replaceState)) {
                $window.history.replaceState({}, '', $window.location.href.slice(0, -1));
            }
        }

        function getCurrentAbsoluteUrl() {
            return $window.location.href;
        }

        function shorten(url) {
            guard.argumentIsString(url);

            var config = {
                cache: true,
                params: {
                    url: url
                }
            };

            return $http.get('/3dprint/url-shorten', config)
                .then(function (response) {
                    return response.data;
                });
        }

        // -----------------------------------------------------------------------------------------

        function getParameters(str) {
            return str.replace(/(^\?)/, '').split("&").map(function (n) {
                return n = n.split("="),
                    (!this[n[0]] ? this[n[0]] = n[1] : ((typeof this[n[0]] === 'object') ?
                        this[n[0]].push(n[1]) :
                        this[n[0]] = [this[n[0]], n[1]])),
                    this;
            }.bind({}))[0];
        }
    }
}());